import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

class Terms extends React.Component {

    render() {
        return (
            <>
                <LandingHeader />

                <div className="about-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="about-items">
                                <div className="col-md-12 about-info">
                                    <h2><span>Terms & Conditions</span></h2>
                                    <blockquote>User's consent is always taken before sending newsletters to our subscribers.</blockquote>
                                    <blockquote>We does not collect any fees for our services.</blockquote>
                                    <blockquote>Usage of this platform is solely by the will of it's users.</blockquote>
                                    <blockquote>We does not send or sell any data to any third party ever.</blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default Terms;
